import {
  Flex,
  SVGButton,
  SelectInput,
  TextInput,
  Hint,
} from "/app/src/component";
import _ from "underscore";
import style from "./style.css";
import React from "react";
const OfflineFormularsContainerStyle = {
  dataName: "OfflineFormularsContainer",
  hAlignContent: "center",
  column: true,
  width: "100%",
  mb: "20px",
  mt: "50px",
  shrink: 0,
  color: "black",
};
const FormularsContainerHeaderStyle = {
  dataName: "FormularsContainerHeader",
  column: true,
  color: "black",
  fontSize: "24px",
  fontWeight: "300",
  w: "70%",
  hAlignContent: "center",
  marginBottom: "15px",
};
const FormularsContainerBodyStyle = {
  dataName: "FormularContainerBody",
  w: "70%",
  fontSize: "24px",
  color: "lightblack",
  fontWeight: "300",
  hAlignContent: "center",
  column: true,
};
const FormularContainerLabelStyle = {
  color: "black",
  fontSize: "24px",
  fontWeight: "300",
  my: "5px",
  hA: "left",
  w: "100%",
};
const Description = {
  color: "black",
  fontSize: "18px",
  my: "5px",
  w: "100%",
  hA: "left",
};
const SmallContainerStyle = {
  maxWidth: "456px",
  width: "100%",
  grow: 1,
};

export default ({ offlineConfig, setOfflineConfig }) => {
  const configClick = (name, type) => {
    offlineConfig[name][type] = !offlineConfig[name][type];
    setOfflineConfig(offlineConfig);
  };

  const renderForm = (placeholder, name, aliases) => {
    let visible = offlineConfig[name]["visible"];
    const VisibleButtonProps = {
      src: visible ? "/images/Visible.svg" : "/images/Hidden.svg",
      color: visible ? "blue" : "lightgrey",
      width: "50px",
      onClick: () => configClick(name, "visible"),
    };
    let required = offlineConfig[name]["require"];
    const RequiredButtonProps = {
      src: required ? "/images/Require_Confirmed.svg" : "/images/Require.svg",
      color: required ? (visible ? "blue" : "lightgrey") : "lightgrey",
      width: "50px",
      onClick: () => configClick(name, "require"),
    };

    let Field = null;
    const inputClass = visible
      ? style.UnselectableTextVisible
      : style.UnselectableText;
    if (!_.isEmpty(aliases)) {
      const inputClass = visible
        ? style.UnselectableTextVisible
        : style.UnselectableText;
      Field = (
        <SelectInput
          values={aliases}
          select={offlineConfig[name].alias}
          onChange={(e) => {
            offlineConfig[name].alias = e.target.value;
            setOfflineConfig(offlineConfig);
          }}
          width="70%"
          name="visitor"
          className={inputClass}
        />
      );
    } else {
      Field = (
        <TextInput
          className={inputClass}
          placeholder={placeholder}
          disabled
          w="70% !important"
        />
      );
    }

    return (
      <Flex width="100%" userSelect="none">
        {Field}
        <SVGButton {...VisibleButtonProps} />
        <SVGButton {...RequiredButtonProps} />
      </Flex>
    );
  };

  return (
    <Flex {...OfflineFormularsContainerStyle}>
      <Flex {...FormularsContainerHeaderStyle}>
        <Flex {...FormularContainerLabelStyle} {...SmallContainerStyle}>
          Offlineformulär
          <Hint
            style={{ marginLeft: "5px" }}
            position="right"
            tooltip="Aktiveras antingen direkt eller genom schemaläggning nedan."
          />
        </Flex>
        <Flex {...Description} {...SmallContainerStyle}>
          Istället för chatten möts besökarna av ett uppgiftsformulär. Välj
          nedan vilka uppgifter ni vill be om.
        </Flex>
      </Flex>
      <Flex {...FormularsContainerBodyStyle}>
        <Flex {...SmallContainerStyle} userSelect="none" fontSize="14px">
          <Flex w="70%" shrink={0}></Flex>
          <Flex width="50px" center>
            Visa
          </Flex>
          <Flex width="50px" center>
            Kräv
          </Flex>
        </Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("E-mail", "email", [])}
        </Flex>
        <Flex {...SmallContainerStyle}>{renderForm("Namn", "name", [])}</Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("Telefonnummer", "phone", [])}
        </Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("Referensnummer", "customer_ref", {
            ref: "Referensnummer",
            ord: "Ordernummer",
            cust: "Kundnummer",
          })}
        </Flex>
        <Flex {...SmallContainerStyle}>
          <Flex
            className={style.UnselectableTextVisible}
            w="70% !important"
            h="100px !important"
            color="#898989"
            fontWeight="300"
            shrink={0}
            mt="5px"
            userSelect="none"
          >
            Meddelande
          </Flex>
          <SVGButton
            src="/images/Visible_Locked_M.svg"
            color="lightgrey"
            width="50px"
          />
          <SVGButton
            src="/images/Require_Confirmed_Locked_M.svg"
            color="lightgrey"
            width="50px"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_OfflineFormular.js